import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65b72873"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = {
  class: "w-100 mx-auto px-3 mt-0 py-0 position-fixed",
  id: "leaf-container"
}
const _hoisted_4 = {
  class: "mx-auto start-0 end-0",
  id: "text-container"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 2,
  class: "mx-auto text-center mt-5 w-75"
}
const _hoisted_8 = {
  key: 0,
  class: "mx-auto mt-5 d-flex justify-content-start flex-column animated-list"
}
const _hoisted_9 = { class: "w-100 d-flex justify-content-start" }
const _hoisted_10 = { class: "ms-3" }
const _hoisted_11 = ["src"]
const _hoisted_12 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Vue3Lottie = _resolveComponent("Vue3Lottie")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Vue3Lottie, {
          class: "mt-5",
          animationData: _ctx.lottieAnimation,
          height: 300,
          width: 350,
          loop: true,
          speed: 1,
          autoPlay: true
        }, null, 8, ["animationData"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.showText)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              id: "loader-title",
              innerHTML: _ctx.t('CL_OFFER_LOADER_TITLE')
            }, null, 8, _hoisted_5))
          : _createCommentVNode("", true),
        (_ctx.showText && _ctx.isTreatmentOneFunnel)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              id: "loader-subtitle",
              class: "px-4",
              innerHTML: _ctx.t('CL_OFFER_LOADER_SUBTITLE')
            }, null, 8, _hoisted_6))
          : _createCommentVNode("", true),
        (!_ctx.isTreatmentOneFunnel)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_ctx.showText)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (index) => {
                      return _createElementVNode("li", {
                        class: "my-0 py-0 fade-in",
                        key: index,
                        style: _normalizeStyle({ animationDelay: index + 1 + 's' })
                      }, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("img", {
                              alt: "checkmark",
                              src: `${_ctx.useAsset('img/credit-line/checkmark.png')}`
                            }, null, 8, _hoisted_11)
                          ]),
                          _createElementVNode("p", {
                            class: "check-legend text-start ms-2",
                            innerHTML: _ctx.t(`CL_OFFER_LOADER.${index}`)
                          }, null, 8, _hoisted_12)
                        ])
                      ], 4)
                    }), 64))
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}